import React from 'react';
import {
  Box,
  Container,
  Grid,
  GridItem,
  SystemStyleObject,
} from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { PiArrowUpRight } from 'react-icons/pi';
import CardMandiri from '../../assets/webp/card-mandiri.webp';
import CardTerbimbing from '../../assets/webp/card-terbimbing.webp';
import CardPengetahuan from '../../assets/webp/card-pengetahuan.webp';
import BgNewPintar from '../../assets/webp/bg-new-pintar.webp';

// Komponen untuk CardItem (judul & deskripsi sudah ada di dalam image)
interface CardItemProps {
  backgroundSrc: string;
  title: string;
  navigatePath: string;
}

// Feedback interaksi card. Hover dibatasi ke perangkat hover-capable agar
// tidak "nyangkut" di touch; _active (press) berlaku di semua perangkat.
const CARD_INTERACTION_SX: SystemStyleObject = {
  WebkitTapHighlightColor: 'transparent',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background:
      'linear-gradient(to top, rgba(29, 178, 84, 0.35), transparent 55%)',
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
  },
  '@media (hover: hover)': {
    '&:hover': {
      cursor: 'pointer',
      transform: 'translateY(-4px)',
      boxShadow: 'xl',
      borderColor: 'green.300',
    },
    '&:hover::after': { opacity: 1 },
    '&:hover [data-cta-badge]': { transform: 'scale(1.12)', bg: 'green.600' },
    '&:hover [data-cta-arrow]': { transform: 'translate(2px, -2px)' },
  },
  '&:active': { transform: 'scale(0.98)', boxShadow: 'md' },
  '&:active::after': { opacity: 1 },
  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&, &:hover, &:active': { transform: 'none' },
    '& [data-cta-badge], & [data-cta-arrow]': {
      transform: 'none',
      transition: 'none',
    },
  },
};

// Penanda visual bahwa card dapat diklik (selalu terlihat, termasuk di touch)
const CardClickBadge: React.FC = () => (
  <Box
    data-cta-badge
    aria-hidden="true"
    position="absolute"
    top={3}
    right={3}
    zIndex={1}
    display="flex"
    alignItems="center"
    justifyContent="center"
    w="36px"
    h="36px"
    rounded="full"
    bg="green.500"
    color="white"
    boxShadow="md"
    pointerEvents="none"
    transition="transform 0.3s ease, background-color 0.3s ease"
  >
    <Box data-cta-arrow display="flex" transition="transform 0.3s ease">
      <PiArrowUpRight size={20} />
    </Box>
  </Box>
);

const CardItem: React.FC<CardItemProps> = ({
  backgroundSrc,
  title,
  navigatePath,
}) => {
  const history = useHistory();

  const handleNavigate = () => {
    history.push(navigatePath);
    window.scrollTo(0, 0);
  };

  return (
    <GridItem
      colSpan={1}
      rounded="lg"
      overflow="hidden"
      display="flex"
      flexDirection="column"
      w="350px"
      h="350px"
      border="1px solid"
      borderColor="gray.200"
      position="relative"
      backgroundImage={`url(${backgroundSrc})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      role="img"
      aria-label={title}
      transition="transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease"
      sx={CARD_INTERACTION_SX}
      onClick={handleNavigate}
    >
      <CardClickBadge />
    </GridItem>
  );
};

const TrainingKnowledge: React.FC = () => {
  return (
    <Box
      backgroundImage={`url(${BgNewPintar})`}
      backgroundSize="cover"
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
    >
      <Container maxW="8xl" my={{ base: 8, md: 12 }}>
        <Grid
          templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(3, 0.3fr)' }}
          alignItems="center"
          justifyContent="center"
          justifyItems="center"
          gap={4}
        >
          <CardItem
            backgroundSrc={CardMandiri}
            title="Pusat Pembelajaran Mandiri"
            navigatePath="/pelatihan"
          />
          <CardItem
            backgroundSrc={CardTerbimbing}
            title="Pusat Pembelajaran Terbimbing"
            navigatePath="/klinik-pengetahuan"
          />
          <CardItem
            backgroundSrc={CardPengetahuan}
            title="Pusat Berbagi Pengetahuan"
            navigatePath="/daftar-pengetahuan"
          />
        </Grid>
      </Container>
    </Box>
  );
};

export default TrainingKnowledge;
